<template>
  <vs-row vs-justify="center" id="Forms-box">
    <vs-col vs-lg="2" class="mr-auto mb-4">
      <vs-button
        class="w-100"
        id="add-Booking-Field-form"
        color="primary"
        @click="$router.go(-1)"
        >{{ $t("Forms.Return") }}</vs-button
      >
    </vs-col>
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <div slot="header">
          <vs-row>
            <vs-col vs-lg="6">
              <vs-button
                class="w-100"
                id="add-Booking-Field-form"
                icon="add"
                color="primary"
                @click="updateQstPrompt('create', {})"
                >{{ $t("Forms.RDV.AddQstTitle") }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>

        <div>
          <div class="px-4 py-3">
            <span style="font-size: 17px; padding-bottom: 10px"
              >{{ $t("Forms.RDV.IdInvestigation") }} :
              {{ selectedInv.id }}</span
            >

            <div v-if="selectedInv.questions.length">
              <div
                v-for="(itemQ, index) in selectedInv.questions"
                :key="index"
                style="
                  border: 2px solid var(--primary);
                  border-radius: 5px;
                  margin-bottom: 10px;
                  font-size: 13px;
                "
              >
                <div
                  style="
                    margin: 10px 10px;
                    display: flex;
                    justify-content: flex-start;
                  "
                >
                  <span style="margin: auto 0"
                    >{{ $t("Forms.RDV.QuestionNbre") }} {{ index + 1 }} :
                  </span>
                  <span style="margin: auto 30px">{{ itemQ.question }}</span>
                  <div>
                    <vs-button
                      id="edit-service-button"
                      color="primary"
                      size="small"
                      icon="add"
                      class="mr-2"
                      @click="updateAnsPrompt('create', itemQ)"
                    ></vs-button>
                    <vs-button
                      id="edit-service-button"
                      color="warning"
                      size="small"
                      icon="edit"
                      class="mr-2"
                      @click="updateQstPrompt('update', itemQ)"
                    ></vs-button>
                    <vs-button
                      id="edit-service-button"
                      color="danger"
                      size="small"
                      icon="delete"
                      @click="updateQstPrompt('delete', itemQ)"
                    ></vs-button>
                  </div>
                </div>
                <div v-if="itemQ.answers.length">
                  <div v-for="(itemA, index) in itemQ.answers" :key="index">
                    <div
                      style="
                        margin: 10px 10px;
                        display: flex;
                        justify-content: flex-start;
                      "
                    >
                      <span style="margin: auto 0; padding-left: 40px">
                        &#8226; {{ $t("Forms.RDV.AnswerNbre") }}
                        {{ index + 1 }} :
                      </span>
                      <span style="margin: auto 30px">{{ itemA.answer }}</span>
                      <vs-button
                        id="edit-service-button"
                        color="warning"
                        size="small"
                        icon="edit"
                        class="mr-2"
                        @click="updateAnsPrompt('update', itemA)"
                      ></vs-button>
                      <vs-button
                        id="edit-service-button"
                        color="danger"
                        size="small"
                        icon="delete"
                        @click="updateAnsPrompt('delete', itemA)"
                      ></vs-button>
                    </div>
                  </div>
                  <div></div>
                </div>
                <div class="answer-style" v-else>
                  <span>{{ $t("Forms.RDV.NoAnswer") }}</span>
                </div>
              </div>
            </div>
            <div class="question-style" v-else>
              <span>{{ $t("Forms.RDV.NoQuestion") }}</span>
            </div>
          </div>
        </div>
      </vs-card>
      <!-- <vs-prompt
        color="primary"
        @accept="createQuestion"
        @close="close"
        @cancel="close"
        :active.sync="activeShowQst"
        :title="$t('Forms.RDV.CreateQstTitle')"
        :accept-text="$t('Forms.RDV.Create')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="px-4 py-3">
              <span style="font-size: 17px; padding-bottom: 10px"
                >Id of Investigation : {{ selectedInv.id }}</span
              >

              <div v-if="selectedInv.questions">
                <div
                  v-for="(itemQ, index) in selectedInv.questions"
                  :key="index"
                  style="
                    border: 2px solid var(--primary);
                    border-radius: 5px;
                    margin-bottom: 10px;
                    font-size: 13px;
                  "
                >
                  <div
                    style="
                      margin-bottom: 5px;
                      display: flex;
                      justify-content: space-around;
                    "
                  >
                    <span style="margin: auto 0"
                      >Question number {{ index + 1 }} :
                    </span>
                    <span style="margin: auto 0">{{ itemQ.question }}</span>
                    <div>
                      <vs-button
                        id="edit-service-button"
                        color="warning"
                        size="small"
                        icon="edit"
                        class="mr-2"
                        @click="updateAnsPrompt(data[indextr])"
                      ></vs-button>
                      <vs-button
                        id="edit-service-button"
                        color="danger"
                        size="small"
                        icon="delete"
                        @click="updateQstPrompt(data[indextr])"
                      ></vs-button>
                    </div>
                  </div>
                  <div v-if="itemQ.answers">
                    <div v-for="(itemA, index) in itemQ.answers" :key="index">
                      <span
                        >Answer number {{ index + 1 }} :
                        {{ itemA.answer }}</span
                      >
                    </div>
                  </div>
                  <div v-else>
                    <span>There's no answers for this question</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <span>THer's no questions for this question</span>
              </div>
            </div>
          </div>
        </div>
      </vs-prompt> -->
      <!-- Add Question -->
      <vs-prompt
        color="primary"
        @accept="createQuestion"
        @close="close"
        @cancel="close"
        :active.sync="activeCreateQst"
        :title="$t('Forms.RDV.AddQstTitle')"
        :accept-text="$t('Forms.RDV.Create')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.IdInvestigation") }} :
                {{ this.selectedInv.id }}</span
              >

              <vs-select
                :label="$t('Forms.RDV.Status')"
                v-model="statusQst"
                class="w-100 mb-2"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in statusArray"
                />
              </vs-select>
              <vs-input
                :label="$t('Forms.RDV.QuestionEn')"
                v-model="questionEn"
                class="w-100 mb-2"
              />

              <vs-input
                :label="$t('Forms.RDV.QuestionAr')"
                v-model="questionAr"
                class="w-100 mb-2"
              />
              <vs-input
                :label="$t('Forms.RDV.QuestionFr')"
                v-model="questionFr"
                class="w-100 mb-2"
              />
            </div>
          </div>
        </div>
      </vs-prompt>
      <!-- Update Question -->
      <vs-prompt
        color="primary"
        @accept="updateQuestion"
        @close="close"
        @cancel="close"
        :active.sync="activeUpdateQst"
        :title="$t('Forms.RDV.UpdateQstTitle')"
        :accept-text="$t('Forms.RDV.Update')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.Question") }} :
                {{ selectedQuestion.question }}</span
              >

              <vs-select
                :label="$t('Forms.RDV.Status')"
                v-model="selectedQuestion.status"
                class="w-100 mb-2"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in statusArray"
                />
              </vs-select>
              <div v-if="selectedQuestion.translations">
                <vs-input
                  :label="$t('Forms.RDV.QuestionEn')"
                  v-model="selectedQuestion.translations.en"
                  class="w-100 mb-2"
                />

                <vs-input
                  :label="$t('Forms.RDV.QuestionAr')"
                  v-model="selectedQuestion.translations.ar"
                  class="w-100 mb-2"
                />
                <vs-input
                  :label="$t('Forms.RDV.QuestionFr')"
                  v-model="selectedQuestion.translations.fr"
                  class="w-100 mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </vs-prompt>

      <!-- Add Answer -->
      <vs-prompt
        color="primary"
        @accept="createAnswer"
        @close="close"
        @cancel="close"
        :active.sync="activeCreateAns"
        :title="$t('Forms.RDV.AddAnswerTitle')"
        :accept-text="$t('Forms.RDV.Create')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.AddAnswerQst") }} :
                {{ this.selectedQuestion.question }}</span
              >

              <vs-input
                :label="$t('Forms.RDV.QuestionEn')"
                v-model="answerEn"
                class="w-100 mb-2"
              />

              <vs-input
                :label="$t('Forms.RDV.QuestionAr')"
                v-model="answerAr"
                class="w-100 mb-2"
              />
              <vs-input
                :label="$t('Forms.RDV.QuestionFr')"
                v-model="answerFr"
                class="w-100 mb-2"
              />
            </div>
          </div>
        </div>
      </vs-prompt>

      <!-- Update Answer -->
      <vs-prompt
        color="primary"
        @accept="updateAnswer"
        @close="close"
        @cancel="close"
        :active.sync="activeUpdateAns"
        :title="$t('Forms.RDV.UpdateAnsTitle')"
        :accept-text="$t('Forms.RDV.Update')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.UpdateAnsTitle") }} :
                {{ selectedAnswer.answer }}</span
              >

              <div v-if="selectedAnswer.translations">
                <vs-input
                  :label="$t('Forms.RDV.AnswerEn')"
                  v-model="selectedAnswer.translations.en"
                  class="w-100 mb-2"
                />

                <vs-input
                  :label="$t('Forms.RDV.AnswerAr')"
                  v-model="selectedAnswer.translations.ar"
                  class="w-100 mb-2"
                />
                <vs-input
                  :label="$t('Forms.RDV.AnswerFr')"
                  v-model="selectedAnswer.translations.fr"
                  class="w-100 mb-2"
                />
              </div>
            </div>
          </div>
        </div>
      </vs-prompt>

      <!-- Delete Question -->
      <vs-prompt
        color="primary"
        @accept="deleteQuestion"
        @close="close"
        @cancel="close"
        :active.sync="activeDeleteQst"
        :title="$t('Forms.RDV.DeleteQuestionTitle')"
        :accept-text="$t('Forms.RDV.Update')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.DeleteQuestion") }} :
                {{ selectedQuestion.question }}</span
              >
            </div>
          </div>
        </div>
      </vs-prompt>

      <!-- Delete Answer -->
      <vs-prompt
        color="primary"
        @accept="deleteAnswser"
        @close="close"
        @cancel="close"
        :active.sync="activeDeleteAns"
        :title="$t('Forms.RDV.DeleteAnswerTitle')"
        :accept-text="$t('Forms.RDV.Update')"
        :cancel-text="$t('Forms.RDV.Cancel')"
      >
        <div v-bar class="vs-scrollable">
          <div>
            <div class="con-exemple-prompt px-4 py-3">
              <span
                >{{ $t("Forms.RDV.DeleteAnswer") }} :
                {{ selectedAnswer.answer }}</span
              >
            </div>
          </div>
        </div>
      </vs-prompt>
    </vs-col>
  </vs-row>
</template>

<script>
import { investigationsService } from "../../_services";

export default {
  name: "Forms",
  data: () => ({
    selected: {},
    activeCreateQst: false,
    activeUpdateQst: false,
    activeShowQst: false,
    activeCreateAns: false,
    activeUpdateAns: false,
    activeDeleteQst: false,
    activeDeleteAns: false,
    selectedInv: {},
    selectedQuestion: {},
    selectedAnswer: {},
    statusQst: 0,
    questionEn: "",
    questionFr: "",
    questionAr: "",
    answerEn: "",
    answerFr: "",
    answerAr: "",
    name: "",
    statusArray: [
      { text: "Active", value: 1 },
      { text: "Incative", value: 0 },
    ],
    statusInv: 0,
    type: "",
    activeAddBookingFieldPrompt: false,
    activeUpdateBookingFieldPrompt: false,
    activeApprovalPrompt: false,
  }),
  methods: {
    close() {
      this.selectedInv = {};
      this.activeCreateQst = false;
      this.activeUpdateQst = false;
      this.activeShowQst = false;
      this.activeCreateAns = false;
      this.activeUpdateAns = false;
      this.activeDeleteQst = false;
      this.activeDeleteAns = false;
      this.questionEn = "";
      this.questionAr = "";
      this.questionFr = "";
      this.statusQst = 0;
      this.statusQst = 0;
    },
    handleSelected(item) {
      this.selectedInv = item;
      this.activeShowQst = true;
    },
    createQuestion() {
      this.showLoading();
      let question = new FormData();
      let questionContent = {
        en: this.questionEn,
        ar: this.questionAr,
        fr: this.questionFr,
      };
      question.append("investigation_id", this.selectedInv.id);
      question.append("status", this.statusQst);
      question.append("question", JSON.stringify(questionContent));
      question.append("_method", "POST");
      investigationsService.createQuestion(question).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
              this.$router.go(-1);
            });
        }.bind(this)
      );
    },
    createAnswer() {
      this.showLoading();
      let answer = new FormData();
      let answerContent = {
        en: this.answerEn,
        ar: this.answerAr,
        fr: this.answerFr,
      };
      answer.append("question_id", this.selectedQuestion.id);
      answer.append("answer", JSON.stringify(answerContent));
      answer.append("_method", "POST");
      investigationsService.createAnswer(answer).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
              this.$router.go(-1);
            });
        }.bind(this)
      );
    },
    updateQuestion() {
      this.showLoading();
      let question = new FormData();
      let questionContent = {
        en: this.selectedQuestion.translations.en,
        ar: this.selectedQuestion.translations.ar,
        fr: this.selectedQuestion.translations.fr,
      };
      question.append("status", this.selectedQuestion.status);
      question.append("question", JSON.stringify(questionContent));
      question.append("_method", "POST");
      investigationsService
        .updateQuestion(this.selectedQuestion.id, question)
        .then(
          function (res) {
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
              "success"
            );
            investigationsService
              .getAll()
              .then(
                function (res) {
                  this.investigations = res.investigations;
                }.bind(this)
              )
              .finally(() => {
                this.hideLoading();
                this.$router.go(-1);
              });
          }.bind(this)
        );
    },
    updateAnswer() {
      this.showLoading();
      let answer = new FormData();
      let answerContent = {
        en: this.selectedAnswer.translations.en,
        ar: this.selectedAnswer.translations.ar,
        fr: this.selectedAnswer.translations.fr,
      };
      answer.append("answer", JSON.stringify(answerContent));
      answer.append("_method", "POST");
      investigationsService.updateAnswer(this.selectedAnswer.id, answer).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
              this.$router.go(-1);
            });
        }.bind(this)
      );
    },

    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    showLoading() {
      this.$vs.loading({
        container: "#Forms-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#Forms-box > .con-vs-loading");
    },

    deleteQuestion() {
      this.showLoading();
      investigationsService.deleteQuestion(this.selectedQuestion.id).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
              this.$router.go(-1);
            });
        }.bind(this)
      );
    },
    deleteAnswser() {
      this.showLoading();
      investigationsService.deleteAnswer(this.selectedAnswer.id).then(
        function (res) {
          this.notify(
            this.$t("Toasts.Successful"),
            this.$t("Customer.CreateCustomerPrompt.ToastSuccessMessage"),
            "success"
          );
          investigationsService
            .getAll()
            .then(
              function (res) {
                this.investigations = res.investigations;
              }.bind(this)
            )
            .finally(() => {
              this.hideLoading();
              this.$router.go(-1);
            });
        }.bind(this)
      );
    },
    updateQstPrompt(value, item) {
      try {
        item.translations = JSON.parse(item.translations);
      } catch (e) {}
      this.selectedQuestion = item;
      if (value == "update") {
        this.activeUpdateQst = true;
      } else if (value == "delete") {
        this.activeDeleteQst = true;
      } else {
        this.activeCreateQst = true;
      }
    },
    updateAnsPrompt(value, item) {
      try {
        item.translations = JSON.parse(item.translations);
      } catch (e) {}
      this.selectedAnswer = item;
      if (value == "update") {
        this.activeUpdateAns = true;
      } else if (value == "delete") {
        this.activeDeleteAns = true;
      } else {
        try {
          item.translations = JSON.parse(item.translations);
        } catch (e) {}
        this.selectedQuestion = item;
        this.activeCreateAns = true;
      }
    },
    close() {
      this.type = "";
      this.name = "";
    },
  },
  mounted() {
    this.selectedInv = JSON.parse(localStorage.getItem("selectedInv"));
    // this.showLoading();
    // investigationsService
    //   .getAll()
    //   .then(
    //     function (res) {
    //       this.investigations = res.investigations;
    //       console.log(this.investigations);
    //     }.bind(this)
    //   )
    //   .finally(() => {
    //     this.hideLoading();
    //   });
  },
};
</script>

<style lang="scss">
.question-style {
  border: 2px solid var(--primary);
  border-radius: 5px;
  margin-bottom: 10px;
  font-size: 13px;
}
.answer-style {
  margin: 10px 10px;
  display: flex;
  justify-content: flex-start;
}
</style>
